import React from "react";
import { FormContextDataProps, FormContextDataType } from "./types";

const FormContextData = React.createContext<FormContextDataType>({} as FormContextDataType);

function FormContextDataProvider(props: FormContextDataProps) {
  const contextValues = React.useMemo(() => {
    return props.data || {};
  }, [props.data]);
  return <FormContextData.Provider value={contextValues}>{props.children}</FormContextData.Provider>;
}

function useFormContextData() {
  const context = React.useContext(FormContextData);
  if (context === undefined) {
    throw new Error(`useFormContextData must be used within a FormContextDataProvider`);
  }
  return context;
}

export { FormContextDataProvider, useFormContextData };
